let lastChatStep = ''

export function startCheckingState(vivrURL: string) {
  console.log('[Five9Chat] startCheckingState called, vivrURL: ' + vivrURL)
  const timerId = setInterval(checkCurrentChatState, 1000)

  function checkCurrentChatState() {
    let now = new Date()

    for (let x in localStorage) {
      if (x.indexOf('f9-chat') >= 0) {
        let jsonObj = JSON.parse(unescape(localStorage.getItem(x) || ''))             

        if (lastChatStep === '' && jsonObj.step === 'Finished') {
          jsonObj.step = 'Overwritten'
          localStorage.setItem(x, escape(JSON.stringify(jsonObj)))
        } else if (lastChatStep === 'Conversation' && jsonObj.step === 'Finished') {          
          // console.log('End of Five9 Chat detected')
          clearInterval(timerId)
          // set values to send to VIVR survey
          launchVIVR(jsonObj, vivrURL)
        }
        lastChatStep = jsonObj.step
      }
    }
  }
}

// Set the chat / email campaigns below.  Please note, these must be the chat / email VCC Campaign names / SCC Profile Names
// Remember you associate a particulat VCC Skill / SCC Group in the SCC configuration for the SCC Profile.
function launchVIVR(jsonObj: any, vivrURL: string) {
  const customerName = `customerName=${jsonObj.information.name}`
  const customerEmail = `customerEmail=${jsonObj.information.email}`
  // const chatQuestion = jsonObj.information.question

  const chatSessionId = `chatSessionId=${jsonObj.session.id}`
  const chatAgentId = `chatAgentId=${jsonObj.session.agent.agentId}`
  const chatAgentName = `chatAgentName=${jsonObj.session.agent.name}`
  // const chatReason = jsonObj.session.customFields.Reason.value

  const url = vivrURL + `?${customerName}&${customerEmail}&${chatSessionId}&${chatAgentId}&${chatAgentName}`
  const newIframe = document.createElement('iframe')
  newIframe.setAttribute('id', 'new-frame')
  newIframe.setAttribute('src', url)
  newIframe.style.height = '550px'
  newIframe.style.width = '320px'
  newIframe.style.border = '1px solid blue'
  newIframe.style.borderRadius = '5px'
  newIframe.style.boxShadow = '0 0 10px 0 rgba(104, 104, 104, 0.75)'

  const divElement = document.querySelector('#five9-frame-full > div.five9-header + div')
  if (divElement) {
    divElement.innerHTML = ''
    divElement.appendChild(newIframe)
  } else {
    console.log('Error: Five9 Chat Survey not initialized!')
  }
}
